import { render, staticRenderFns } from "./ConnectWalletNetworkSelect.vue?vue&type=template&id=0774d9b4"
import script from "./ConnectWalletNetworkSelect.vue?vue&type=script&lang=ts"
export * from "./ConnectWalletNetworkSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports